import React from 'react';
import { ExtractionSchema } from '../../types';
import { Modal } from '../ui';

interface Props {
  schema: ExtractionSchema;
  onClose: () => void;
}

export const SchemaViewerModal: React.FC<Props> = ({ schema, onClose }) => {
  return (
    <Modal isOpen={true} onClose={onClose} title={schema.name} size="lg">
      <p className="text-gray-600 mb-4">
        {schema.domain} - v{schema.version}
      </p>

        <div className="grid grid-cols-3 gap-4 mb-4 text-sm">
          <div>
            <span className="text-gray-500">Status:</span>{' '}
            {schema.is_active ? 'Actif' : schema.is_deprecated ? 'Deprecated' : 'Inactif'}
          </div>
          <div>
            <span className="text-gray-500">Champs:</span>{' '}
            {schema.field_count}
          </div>
          <div>
            <span className="text-gray-500">Créé le:</span>{' '}
            {new Date(schema.created_at).toLocaleDateString('fr-CA', {
              timeZone: 'America/Montreal'
            })}
          </div>
        </div>

        {schema.description && (
          <div className="mb-4">
            <h3 className="font-medium mb-1">Description</h3>
            <p className="text-gray-700">{schema.description}</p>
          </div>
        )}

        <div>
          <h3 className="font-medium mb-2">Schema JSON</h3>
          <pre className="bg-gray-100 p-4 rounded overflow-x-auto text-sm">
            {JSON.stringify(schema.schema_json, null, 2)}
          </pre>
        </div>

        <div className="mt-4 text-sm text-gray-500">
          <p>Créé le: {new Date(schema.created_at).toLocaleString('fr-CA', {
            timeZone: 'America/Montreal'
          })}</p>
          <p>Modifié le: {new Date(schema.updated_at).toLocaleString('fr-CA', {
            timeZone: 'America/Montreal'
          })}</p>
        </div>
    </Modal>
  );
};
